export default __webpack_public_path__ + "static/media/Prologue_Aurora2.3ada6c33.png";